import type * as SchemaTypes from '../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteSubgroupMutationVariables = SchemaTypes.Exact<{
  id: SchemaTypes.Scalars['ObjectID']['input'];
  companyId: SchemaTypes.Scalars['ObjectID']['input'];
}>;


export type DeleteSubgroupMutation = (
  { __typename: 'Mutation' }
  & { deleteSubgroup: (
    { __typename: 'DeleteSubgroupSuccessfulResponse' }
    & Pick<SchemaTypes.DeleteSubgroupSuccessfulResponse, 'success' | 'deletedId'>
  ) | (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) }
);


export const DeleteSubgroupDocument = /*#__PURE__*/ gql`
    mutation DeleteSubgroup($id: ObjectID!, $companyId: ObjectID!) {
  deleteSubgroup(id: $id, companyId: $companyId) {
    __typename
    ... on DeleteSubgroupSuccessfulResponse {
      success
      deletedId
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    `;
export type DeleteSubgroupMutationFn = Apollo.MutationFunction<DeleteSubgroupMutation, DeleteSubgroupMutationVariables>;

/**
 * __useDeleteSubgroupMutation__
 *
 * To run a mutation, you first call `useDeleteSubgroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubgroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSubgroupMutation, { data, loading, error }] = useDeleteSubgroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useDeleteSubgroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSubgroupMutation, DeleteSubgroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSubgroupMutation, DeleteSubgroupMutationVariables>(DeleteSubgroupDocument, options);
      }
export type DeleteSubgroupMutationHookResult = ReturnType<typeof useDeleteSubgroupMutation>;
export type DeleteSubgroupMutationResult = Apollo.MutationResult<DeleteSubgroupMutation>;
export type DeleteSubgroupMutationOptions = Apollo.BaseMutationOptions<DeleteSubgroupMutation, DeleteSubgroupMutationVariables>;